import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/Button';
import { ArrowRight, ChevronDown, FileText } from 'lucide-react';
import { ThreeBackground } from './ThreeBackground';
export function HeroSection() {
  const navigate = useNavigate();
  const scrollToAbout = () => {
    const element = document.querySelector('#about');
    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-navy-900" data-id="element-181">
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-182">
        <ThreeBackground className="absolute inset-0" data-id="element-183" />
        <div className="absolute top-1/4 -left-1/4 w-1/2 h-1/2 bg-gold/5 rounded-full blur-[120px]" data-id="element-184"></div>
        <div className="absolute bottom-1/4 -right-1/4 w-1/2 h-1/2 bg-navy-400/10 rounded-full blur-[120px]" data-id="element-185"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-186">
        <div className="flex flex-col items-center text-center" data-id="element-187">
          {/* Headshot - Centered circular at top */}
          <div className="relative mb-8" data-id="element-188">
            <div className="w-40 h-40 sm:w-48 sm:h-48 lg:w-56 lg:h-56 rounded-full overflow-hidden shadow-2xl shadow-black/50 border-4 border-white/15" data-id="element-189">
              <img src="https://cdn.magicpatterns.com/uploads/v13xUaXmA5yP5frphJP65V/hyt.jpg" alt="Tom Schrepferman - Senior Revenue Executive" className="w-full h-full object-cover object-top" data-id="element-190" />
            </div>
            <div className="absolute -inset-4 bg-gold/10 rounded-full blur-2xl -z-10" data-id="element-191"></div>
          </div>

          {/* Text content - Centered below */}
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-navy-800/50 border border-navy-600/50 text-gold text-sm font-medium mb-6" data-id="element-192">
            <span className="w-2 h-2 rounded-full bg-gold animate-pulse" data-id="element-193"></span>
            Senior Revenue Executive & Fractional CRO
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold tracking-tight mb-6 leading-[1.1]" data-id="element-194">
            Building Revenue Engines That{' '}
            <span className="text-gradient" data-id="element-195">Scale.</span>
          </h1>

          <p className="text-lg sm:text-xl lg:text-2xl text-white/60 mb-10 max-w-2xl leading-relaxed font-light" data-id="element-196">
            25+ years leading enterprise sales growth, scaling B2B
            organizations, and delivering transformative revenue results.
          </p>

          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-4" data-id="element-197">
            <Button size="lg" onClick={() => navigate('/experience')} className="group" data-id="element-198">
              View My Experience
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-199" />
            </Button>
            <Button variant="secondary" size="lg" onClick={() => navigate('/contact')} data-id="element-200">
              Connect With Me
            </Button>
            <Button variant="secondary" size="lg" onClick={() => window.open('https://heyzine.com/flip-book/fa5e29bcc5.html', '_blank')} className="group" data-id="element-201">
              <FileText className="mr-2 w-5 h-5" data-id="element-202" />
              View Resume
            </Button>
            <Button variant="secondary" size="lg" onClick={() => window.open('https://heyzine.com/flip-book/6653e37a9b.html', '_blank')} className="group" data-id="element-203">
              <FileText className="mr-2 w-5 h-5" data-id="element-204" />
              Executive Bio
            </Button>
            <Button variant="secondary" size="lg" onClick={() => window.open('https://heyzine.com/flip-book/6d9826a276.html', '_blank')} className="group" data-id="element-205">
              <FileText className="mr-2 w-5 h-5" data-id="element-206" />
              Executive SWOT Assessment
            </Button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce hidden md:block" data-id="element-207">
        <button onClick={scrollToAbout} className="p-2 rounded-full bg-navy-800/50 text-white/40 hover:text-gold transition-colors" aria-label="Scroll down" data-id="element-208">
          <ChevronDown className="w-6 h-6" data-id="element-209" />
        </button>
      </div>
    </section>;
}